import { useEffect, useState } from "react";

const navItems = [
  { label: "Processing Options", href: "#processing-options" },
  { label: "Services", href: "#services" },
  { label: "Local Info", href: "#service-area" },
  { label: "Travel Timing", href: "#travel-timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
  { label: "Resources", href: "#local-resources" },
];

export default function MarcoIslandStickyNav() {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${isSticky ? "bg-white border-b border-gray-200 shadow-sm" : "bg-[#1A365D]"}`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <a
            href="https://fastpassportcenter.com"
            className={`font-serif text-lg font-bold transition-colors ${isSticky ? "text-[#1A365D]" : "text-white"}`}
          >
            Fast Passport <span className="text-[#F6C344]">Center</span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${isSticky ? "text-[#1A365D] hover:bg-gray-100" : "text-white/80 hover:bg-white/10"}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="ml-3 inline-flex items-center gap-1.5 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-xs px-4 py-2 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden w-9 h-9 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} ${isSticky ? "text-[#1A365D]" : "text-white"} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className={`md:hidden border-t ${isSticky ? "border-gray-200 bg-white" : "border-white/10 bg-[#1A365D]"}`}>
          <div className="px-4 py-3 space-y-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`block px-3 py-2.5 rounded-md text-sm font-medium ${isSticky ? "text-[#1A365D] hover:bg-gray-100" : "text-white/80 hover:bg-white/10"}`}
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="block mt-2 text-center bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-4 py-3 rounded-md transition-all"
            >
              Get Started
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}